import React, { useEffect } from 'react';
import './layout.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WOW from 'wowjs';

// Public Pages
import HomeDefault from "./pages/HomeDefault";
import AboutOne from "./pages/AboutOne";
import RdsoPage from "./pages/RdsoPage";
import ServicesPage from "./pages/ServicesPage";
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage from './pages/ContactPage';
import ProjectPage from './pages/ProjectPage';
import Error from "./pages/Error";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import FloatingContact from './components/floatingContact/FloatingContact';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import { SiteContentProvider } from './context/SiteContentContext';

function App() {
  useEffect(() => {
    new WOW.WOW({
        live: false
      }).init();
    }, []
  );
  return (
      <SiteContentProvider><Router>
        <ScrollToTop/>
        <Routes>
          {/* Public Routes */}
          <Route path={`${process.env.PUBLIC_URL}/`} element={<HomeDefault />} />
          <Route path={`${process.env.PUBLIC_URL}/about`} element={<AboutOne />} />
          <Route path={`${process.env.PUBLIC_URL}/rdso`} element={<RdsoPage />} />
          <Route path={`${process.env.PUBLIC_URL}/services`} element={<ServicesPage />} />
          <Route path={`${process.env.PUBLIC_URL}/projects`} element={<ProjectPage />} />
          <Route path={`${process.env.PUBLIC_URL}/testimonials`} element={<TestimonialsPage />} />
          <Route path={`${process.env.PUBLIC_URL}/contact`} element={<ContactPage />} />

          {/* Fallback 404 Route */}
          <Route path={`${process.env.PUBLIC_URL}/*`} element={<Error />} />
        </Routes>
        <FloatingContact/>
      </Router></SiteContentProvider>
  );
}

export default App;
